import baseRoute from '../baseRoute';

export default `${baseRoute}/sale` as const;
